import { LocalStorageKeys } from "@/constants/local-storage-keys";

const FLAG_VALUE = "true";

export const markSignedInBefore = (): void => {
  try {
    localStorage.setItem(LocalStorageKeys.HAS_SIGNED_IN_BEFORE_KEY, FLAG_VALUE);
  } catch {
    // Private browsing / storage disabled — swallow so auth flows keep working.
  }
};

export const hasSignedInBefore = (): boolean => {
  try {
    return localStorage.getItem(LocalStorageKeys.HAS_SIGNED_IN_BEFORE_KEY) === FLAG_VALUE;
  } catch {
    return false;
  }
};
